import { render, staticRenderFns } from "./TagsSelect.vue?vue&type=template&id=5f697f67"
import script from "./TagsSelect.vue?vue&type=script&lang=js"
export * from "./TagsSelect.vue?vue&type=script&lang=js"
import style0 from "./TagsSelect.vue?vue&type=style&index=0&id=5f697f67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports